import {
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from "nuqs";

import { organizationInvitationStatusParams } from "~/admins/constants/organizations";

export const organizationInvitationsFiltersParser = {
  order: parseAsString.withDefault("desc"),
  order_by: parseAsString.withDefault("last_status_change_at"),
  statuses: parseAsArrayOf(
    parseAsStringLiteral(organizationInvitationStatusParams),
  ).withDefault([...organizationInvitationStatusParams]),
};

export const useOrganizationInvitationsFilters = () => {
  return useQueryStates(organizationInvitationsFiltersParser);
};
